import { Loader2 } from "lucide-react";

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && <p className="eyebrow text-[#4F0341]">{eyebrow}</p>}
        <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-[#1C111A]" data-testid="admin-page-title">{title}</h1>
        {description && <p className="mt-1 text-sm text-[#635060] max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, testId }) {
  return (
    <div className="card-surface p-5" data-testid={testId}>
      <p className="text-xs uppercase tracking-widest font-semibold text-[#635060]">{label}</p>
      <p className="mt-2 font-mono text-3xl font-semibold text-[#1C111A]">{value}</p>
      {hint && <p className="mt-1 text-xs text-[#8a7686]">{hint}</p>}
    </div>
  );
}

export function DataTable({ columns, rows, loading, empty = "Nothing here yet.", testId, onRowClick }) {
  return (
    <div className="card-surface overflow-x-auto" data-testid={testId}>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-[#E9DFE7] bg-[#FAF8FB]">
            {columns.map((c) => <th key={c.key} className={`text-left px-4 py-3 text-xs uppercase tracking-wider font-semibold text-[#635060] whitespace-nowrap ${c.className || ""}`}>{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {loading && <tr><td colSpan={columns.length} className="px-4 py-10 text-center"><Loader2 className="h-5 w-5 animate-spin inline text-[#4F0341]" /></td></tr>}
          {!loading && rows?.length === 0 && <tr><td colSpan={columns.length} className="px-4 py-10 text-center text-[#8a7686]" data-testid={`${testId}-empty`}>{empty}</td></tr>}
          {!loading && rows?.map((r, i) => (
            <tr key={r.id || i} onClick={onRowClick ? () => onRowClick(r) : undefined} className={`border-b border-[#E9DFE7] last:border-0 ${onRowClick ? "cursor-pointer hover:bg-[#FAF8FB]" : ""}`} data-testid={`${testId}-row-${r.id || i}`}>
              {columns.map((c) => <td key={c.key} className={`px-4 py-3 align-top ${c.className || ""}`}>{c.render ? c.render(r) : r[c.key] ?? "-"}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function PrimaryButton({ busy, children, className = "", ...props }) {
  return (
    <button disabled={busy || props.disabled} className={`btn-pill h-10 inline-flex items-center justify-center gap-2 bg-[#4F0341] text-white hover:bg-[#721862] disabled:opacity-60 ${className}`} {...props}>
      {busy && <Loader2 className="h-4 w-4 animate-spin" />}{children}
    </button>
  );
}

export function GhostButton({ children, className = "", ...props }) {
  return <button className={`btn-pill h-9 px-4 inline-flex items-center gap-2 border border-[#E9DFE7] bg-white text-[#1C111A] hover:bg-[#F3E8F1] disabled:opacity-50 ${className}`} {...props}>{children}</button>;
}
